module.exports = __webpack_public_path__ + "static/media/mo-icon-3.5ef16f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mo/mo-icon-3.png
// module id = 80
// module chunks = 0